import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { addToListLinkStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsAddToListLink";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { css } from "styled-components";

addToListLinkStyles.wrapper = mergeToNew(addToListLinkStyles.wrapper, {
    css: css`
        text-align: center;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        margin-top: 10px;
                    `,
                    null,
                    css`
                        margin-top: 30px;
                    `,
                ],
                "min",
            )}
    `,
});
